import * as actions from './actions';

import { ActionType, createReducer } from 'typesafe-actions';

import { ACTION_STATUSES } from 'shared/consts/consts';
import { TenantPortalsState } from './types';

export const INITIAL_STATE: TenantPortalsState = {
  tenantPortals: null,
  getTenantPortals: {
    status: null,
    error: null,
  },
};

const getTenantPortalsRequestHandler = (state: TenantPortalsState): TenantPortalsState => ({
  ...state,
  getTenantPortals: {
    error: null,
    status: ACTION_STATUSES.PENDING,
  },
});

const getTenantPortalsSuccessHandler = (
  state: TenantPortalsState,
  { payload }: ActionType<typeof actions.getTenantPortals.success>,
): TenantPortalsState => ({
  ...state,
  tenantPortals: payload,
  getTenantPortals: {
    error: null,
    status: ACTION_STATUSES.FULFILLED,
  },
});

const getTenantPortalsFailureHandler = (
  state: TenantPortalsState,
  { payload }: ActionType<typeof actions.getTenantPortals.failure>,
): TenantPortalsState => ({
  ...state,
  getTenantPortals: {
    error: payload.error,
    status: ACTION_STATUSES.REJECTED,
  },
});

const TenantPortalsReducer = createReducer(INITIAL_STATE)
  .handleAction(actions.getTenantPortals.request, getTenantPortalsRequestHandler)
  .handleAction(actions.getTenantPortals.success, getTenantPortalsSuccessHandler)
  .handleAction(actions.getTenantPortals.failure, getTenantPortalsFailureHandler);

export default TenantPortalsReducer;
